export enum AppUiStatus {
  zero = 'zero',
  creating = 'creating',
  loading = 'loading',
  complete = 'complete',
}
